import * as React from 'react';
import { Badge, makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { Flash16Regular, Flash20Regular, TaskListSquareLtr16Regular, TaskListSquareLtr20Regular } from '@fluentui/react-icons';
import IPoll from '../../model/IPoll';
import { getPollTypeLabel, isQuickPoll } from '../../lib/pollLabels';

const useStyles = makeStyles({
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        borderRadius: tokens.borderRadiusMedium,
        color: tokens.colorBrandForeground1,
        backgroundColor: tokens.colorBrandBackground2,
        flexShrink: 0,
    },
});

/** Compact square icon for tables and cards. */
export const PollTypeIcon: React.FC<{ poll: IPoll }> = ({ poll }) => {
    const styles = useStyles();
    const quick = isQuickPoll(poll.Type, poll.Quick);
    const label = getPollTypeLabel(poll.Type, poll.Quick);
    return (
        <Tooltip content={`${label} опрос`} relationship="label" withArrow>
            <span className={styles.icon} aria-label={`${label} опрос`}>
                {quick === false ? <TaskListSquareLtr20Regular /> : <Flash20Regular />}
            </span>
        </Tooltip>
    );
};

/** Text badge for headers. */
const PollTypeBadge: React.FC<{ poll: IPoll }> = ({ poll }) => {
    const quick = isQuickPoll(poll.Type, poll.Quick);
    return (
        <Badge
            appearance="outline"
            color="brand"
            shape="rounded"
            icon={quick === false ? <TaskListSquareLtr16Regular /> : <Flash16Regular />}
        >
            {getPollTypeLabel(poll.Type, poll.Quick)}
        </Badge>
    );
};

export default PollTypeBadge;
